import { UrlMatchResult, UrlSegment } from '@angular/router'
import { PUBLIC_PAGE_PREFIX, publicPageSegment } from '@seiri/shared/common'

/**
 * The public premise page: `/@:id`, or `/@:id/:view` with `view` one of the page's tab segments. `id` is the slug
 * without its `@`, so the page reads the same params whichever URL it came from.
 */
export function publicPageMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const [first, view] = segments
  if (!first?.path.startsWith(PUBLIC_PAGE_PREFIX) || segments.length > 2) return null
  const id = first.path.slice(PUBLIC_PAGE_PREFIX.length)
  if (!id) return null
  const posParams = { id: new UrlSegment(id, first.parameters) }
  return { consumed: segments, posParams: view ? { ...posParams, view } : posParams }
}

/**
 * The public page's URL before 2026-10-22, `/:id` or `/:id/:view`, which the router redirects to its `@` form
 * (`legacyPublicPageRedirect`). A first segment that already starts with `@` is not one: a bare `/@` would otherwise
 * become `/@@`.
 */
export function legacyPublicPageMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const [id, view] = segments
  if (!id || id.path.startsWith(PUBLIC_PAGE_PREFIX) || segments.length > 2) return null
  return { consumed: segments, posParams: view ? { id, view } : { id } }
}

/** The router commands of the `@` URL an old `/:id[/:view]` link stands for. */
export function legacyPublicPageRedirect(params: { id: string; view?: string }): string[] {
  return ['/', publicPageSegment(params.id), ...(params.view ? [params.view] : [])]
}
